// extracted by mini-css-extract-plugin
export default {"landingPageOuterWrapper":"landingPageStyles_landingPageOuterWrapper__uXMIH","innerWrapper":"landingPageStyles_innerWrapper__vElTx"};